var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLearnWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-learn-white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.756,
    height: 132.815,
    viewBox: "0 0 132.756 132.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1171",
    "data-name": "Caminho 1171",
    d: "M94.119,47.472a4.633,4.633,0,1,1,.065,0h-.065M93.17,34.879a3.445,3.445,0,0,1-.41.126,7.955,7.955,0,1,0,4,.315c-.511-.177-1.042-.3-1.564-.441Z",
    transform: "translate(-86.242 -34.879)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1172",
    "data-name": "Caminho 1172",
    d: "M182.173,59.151a1.516,1.516,0,1,0,0,3.031h47.474a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(-180.657 -59.151)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1173",
    "data-name": "Caminho 1173",
    d: "M51.685,104.289a4.354,4.354,0,0,1-.01-.443q0-6.577,0-13.155a5.836,5.836,0,0,1,6.554-5.96,1.238,1.238,0,0,1,.6.289c.724.578,1.421,1.193,2.148,1.768a5.984,5.984,0,0,0,7.687,0c.726-.577,1.415-1.2,2.148-1.767a1.521,1.521,0,0,1,.791-.288A7.4,7.4,0,0,1,77.778,87.2c.93,1,1.939,1.937,2.9,2.916a2.058,2.058,0,0,0,1.576.658q2.878-.025,5.755,0a2.069,2.069,0,0,1,2.156,2.147,1.984,1.984,0,0,1-1.632,1.906,4.515,4.515,0,0,1-.817.067q-1.267,0-2.533,0c-1.433,0-2.865,0-4.3.009a2.7,2.7,0,0,1-2.135-.891c-.716-.773-1.476-1.506-2.233-2.239a3.456,3.456,0,0,0-5.939,2.344c-.014.231-.005.464-.005.7v30.34h-4.1v-.744q0-9.549,0-19.1c0-1.177-.636-1.9-1.641-1.906a1.615,1.615,0,0,0-1.629,1.456,6.653,6.653,0,0,0-.013.695q0,9.392,0,18.783v.792H59.061V105.273q0-6.322,0-12.643c0-1.246-.687-1.959-1.769-1.885a1.559,1.559,0,0,0-1.448,1.28,5.068,5.068,0,0,0-.057.881c0,2.952,0,5.9,0,8.854,0,.8-.026,1.6-.048,2.4a1.944,1.944,0,0,1-1.912,1.95l-.089,0a2.046,2.046,0,0,1-2.048-1.824m46.7-25.143c-.221.226-.428.466-.638.7q-3.409,3.823-6.811,7.653a.851.851,0,0,1-1.109.321,6.034,6.034,0,0,0-1.913-.324c-.8-.022-1.6-.02-2.4-.018-.761,0-1.521,0-2.281-.015a1.522,1.522,0,0,1-.918-.389c-.969-.908-1.885-1.871-2.836-2.8a9.99,9.99,0,0,0-4.224-2.44,13.972,13.972,0,0,0-4.765-.37,2.21,2.21,0,0,0-1.123.5c-.949.735-1.845,1.539-2.783,2.289a2.694,2.694,0,0,1-3.541-.025,15.149,15.149,0,0,1-1.74-1.464,4.636,4.636,0,0,0-4.009-1.347,9.027,9.027,0,0,0-8.864,8.527c-.126,4.8-.073,9.613-.01,14.418a5.2,5.2,0,0,0,5.005,5,18.045,18.045,0,0,0,2.313-.206v15.99H43.384a1.654,1.654,0,1,0,0,3.309h101.6a1.654,1.654,0,1,0,0-3.309H73.919V93.924c.225.174.361.26.473.371.749.741,1.491,1.49,2.239,2.233a5.073,5.073,0,0,0,3.6,1.611c2.739.025,5.485.11,8.218-.024a5.246,5.246,0,0,0,4.559-7.4.61.61,0,0,1,.123-.769c1.373-1.515,2.73-3.045,4.091-4.572,1.206-1.353,2.426-2.694,3.61-4.066a1.593,1.593,0,0,0-.126-2.32,1.569,1.569,0,0,0-1.051-.407,1.789,1.789,0,0,0-1.272.568",
    transform: "translate(-41.729 -78.578)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1174",
    "data-name": "Caminho 1174",
    d: "M231.887,81.264a1.516,1.516,0,1,0,0,3.031h30.537a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(-230.371 -81.264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1175",
    "data-name": "Caminho 1175",
    d: "M224.387,103.376a1.516,1.516,0,1,0,0,3.031h33.092a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(-222.871 -103.376)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1176",
    "data-name": "Caminho 1176",
    d: "M208.316,125.489a1.516,1.516,0,1,0,0,3.031h38.567a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(-206.8 -125.489)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1177",
    "data-name": "Caminho 1177",
    d: "M203.939,34.878H162.158a1.644,1.644,0,1,0,0,3.288H187.7c.052.006.1.016.155.018.231.01.464.005.7.005h30.992c1.569,0,2.13.561,2.13,2.129q0,16.034,0,32.067c0,1.652-.544,2.2-2.193,2.2h-15.5c-.016,0-.03,0-.046,0H162.158a1.644,1.644,0,1,0,0,3.288h41.781l.02,0h.286q7.78,0,15.56,0a4.923,4.923,0,0,0,5.045-3.931,1.109,1.109,0,0,1,.109-.217V39.053c-.115-.333-.214-.673-.347-1A4.851,4.851,0,0,0,220.944,35c-.14-.03-.275-.082-.413-.124Z",
    transform: "translate(-160.514 -34.878)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1178",
    "data-name": "Caminho 1178",
    d: "M33.17,126.883c0-2.127.781-2.929,2.887-2.934q6.312-.012,12.624,0H95.712c3.521,0,4.181.748,3.767,4.371H33.17c0-.54,0-.987,0-1.435m13-8.644a30.833,30.833,0,0,0,6.23-11.127.963.963,0,0,1,1.111-.829c8.575.02,17.15.006,25.725.037a1.256,1.256,0,0,1,.992.563A33.3,33.3,0,0,0,87.209,119a3.763,3.763,0,0,1,.268.5H45.169c.421-.531.7-.9,1-1.261m-34.63-16.4c-3.751,0-6.56-2.241-7.055-5.613a9.606,9.606,0,0,1-.067-1.359c-.006-2.058,0-4.116,0-6.265H128.26a76.4,76.4,0,0,1-.052,7.727,6.387,6.387,0,0,1-6.483,5.5c-3.26.037-6.52.01-9.78.01H64.132q-26.3,0-52.593,0M4.413,82.755q0-35.6,0-71.2c0-4.376,2.727-7.105,7.1-7.106q54.908-.006,109.814,0c4.226,0,7,2.747,7,6.952q.014,35.725.005,71.451v1.24H4.413ZM120.524,0Q83.547.059,46.571.034q-17.875,0-35.752,0A10.934,10.934,0,0,0,.006,10.859Q0,23.76,0,36.662v6.6Q0,69.292.012,95.324a8.993,8.993,0,0,0,.152,1.842,11.078,11.078,0,0,0,11.3,9.129q17.521.012,35.041,0h1.578c-.269.708-.454,1.247-.676,1.771-1.482,3.51-3.864,6.391-6.291,9.274-1.426,1.7-2.975,2.608-5.2,2.224a4.354,4.354,0,0,0-1.111.035,6.593,6.593,0,0,0-6.051,6.525c-.019,1.2,0,2.394,0,3.591,0,2.462.623,3.1,3.038,3.1H70.832q15.212,0,30.423,0c2.007,0,2.738-.742,2.745-2.769,0-1.321.019-2.642,0-3.963a6.565,6.565,0,0,0-6.1-6.474c-.514-.04-1.032-.037-1.548-.034-.557,0-1.114.005-1.667-.045a2.241,2.241,0,0,1-1.388-.579c-1.953-2.232-3.969-4.428-5.7-6.827a51.666,51.666,0,0,1-3.174-5.824h1.872q5.231,0,10.463,0,12.475.005,24.95-.013a11.02,11.02,0,0,0,11.043-11.012q.017-42.17.008-84.34a10.324,10.324,0,0,0-1.886-6.042C128.372,1.316,124.887,0,120.582,0Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1179",
    "data-name": "Caminho 1179",
    d: "M190.555,272.945a2.231,2.231,0,0,0-2.191,2.227,2.2,2.2,0,0,0,4.408-.028,2.23,2.23,0,0,0-2.2-2.2h-.014",
    transform: "translate(-188.365 -272.945)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3935",
    "data-name": "Grupo 3935",
    transform: "translate(29.381 11.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3934",
    "data-name": "Grupo 3934",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1613",
    "data-name": "Ret\\xE2ngulo 1613",
    width: 16.909,
    height: 15.944,
    transform: "translate(-0.488 0)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3937",
    "data-name": "Grupo 3937",
    transform: "translate(61.546 20.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3936",
    "data-name": "Grupo 3936",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1614",
    "data-name": "Ret\\xE2ngulo 1614",
    width: 50.505,
    height: 3.031,
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3939",
    "data-name": "Grupo 3939",
    transform: "translate(14.216 26.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3938",
    "data-name": "Grupo 3938",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1615",
    "data-name": "Ret\\xE2ngulo 1615",
    width: 104.912,
    height: 49.881,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3941",
    "data-name": "Grupo 3941",
    transform: "translate(78.483 27.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3940",
    "data-name": "Grupo 3940",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1616",
    "data-name": "Ret\\xE2ngulo 1616",
    width: 33.569,
    height: 3.031,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3943",
    "data-name": "Grupo 3943",
    transform: "translate(75.928 35.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3942",
    "data-name": "Grupo 3942",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1617",
    "data-name": "Ret\\xE2ngulo 1617",
    width: 36.124,
    height: 3.031,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3945",
    "data-name": "Grupo 3945",
    transform: "translate(70.453 42.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3944",
    "data-name": "Grupo 3944",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1618",
    "data-name": "Ret\\xE2ngulo 1618",
    width: 41.599,
    height: 3.031,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3947",
    "data-name": "Grupo 3947",
    transform: "translate(54.684 11.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3946",
    "data-name": "Grupo 3946",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1619",
    "data-name": "Ret\\xE2ngulo 1619",
    width: 64.445,
    height: 42.993,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3949",
    "data-name": "Grupo 3949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3948",
    "data-name": "Grupo 3948",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1620",
    "data-name": "Ret\\xE2ngulo 1620",
    width: 132.76,
    height: 132.815,
    fill: "url(#linear-gradient)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3951",
    "data-name": "Grupo 3951",
    transform: "translate(64.172 92.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3950",
    "data-name": "Grupo 3950",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1621",
    "data-name": "Ret\\xE2ngulo 1621",
    width: 4.423,
    height: 4.407,
    transform: "translate(-0.008)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLearnWhite);
export default __webpack_public_path__ + "static/media/icon-learn-white.4dd890407221ae80de05502d6c6bf261.svg";
export { ForwardRef as ReactComponent };